import React, { useEffect } from 'react';
import {
  useAuth,
  useClerk,
  SignedIn,
  SignedOut,
  SignInButton,
  SignUpButton
} from '@clerk/clerk-react';
import UserMenu from './UserMenu';

export default function AuthControls() {
  const { isLoaded } = useAuth();
  const clerk = useClerk();

  useEffect(() => {
    function handleStorage(e) {
      // only fire on new broadcasts (newValue !== null)
      if (e.key === 'clerk-signin' && e.newValue) {
        // clear the key so we don't re-fire
        localStorage.removeItem('clerk-signin');
        // reload once to pick up the new session
        window.location.reload();
      }
      if (e.key === 'clerk-signout' && e.newValue) {
        localStorage.removeItem('clerk-signout');
        // clear local Clerk session then reload
        clerk.signOut().then(() => window.location.reload());
      }
    }

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [clerk]);

  if (!isLoaded) return null;

  return (
    <div className="absolute top-0 right-0 p-4 flex items-center space-x-4 z-20">
      <SignedOut>
        <div className="flex space-x-3">
          <SignInButton mode="modal">
            <button className="bg-blue-600 text-white px-4 py-2 rounded-full hover:bg-blue-700 transition">
              Sign In
            </button>
          </SignInButton>
          <SignUpButton mode="modal">
            <button className="bg-white text-blue-600 border border-blue-600 px-4 py-2 rounded-full hover:bg-blue-50 transition">
              Sign Up
            </button>
          </SignUpButton>
        </div>
      </SignedOut>
      <SignedIn>
        <UserMenu />
      </SignedIn>
    </div>
  );
}
